// App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/home/Home';
import Landing from './pages/landing/Landing';
// import SignUp from './pages/landing/SignUp'; // Disabled for security
import ForgotPassword from './pages/landing/ForgotPassword';
import UserAccountMenu from './components/userAccount/UserAccountMenu';
import './App.css';
import forte_logo from './assets/forte_logo_white.svg';
import abbvie_logo from './assets/abbvie_logo_2.png';
import abbvie_logo_main from './assets/abbvie_logo_white.svg';
import cognitoService from './services/cognitoService';

// Protected route component (Cognito SDK)
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;
    cognitoService.isAuthenticated()
      .then((authenticated) => {
        if (isMounted) {
          setIsAuthenticated(authenticated);
          setChecking(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          setIsAuthenticated(false);
          setChecking(false);
        }
      });
    return () => { isMounted = false; };
  }, []);

  if (checking) return <div>Checking authentication...</div>;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return children;
};

// AppContent component to use location
const AppContent = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let isMounted = true;
    cognitoService.isAuthenticated()
      .then((authenticated) => { if (isMounted) setIsAuthenticated(authenticated); })
      .catch(() => { if (isMounted) setIsAuthenticated(false); });
    return () => { isMounted = false; };
  }, [location]);

  document.title = 'AI Test Case Assistant';

  return (
    <div className="App">
      {/* Only show header if not on landing page */}
      {!isLandingPage && (
        <header className="App-header">
          <div className="header-content">
            <div className="logo-container">
              <img src={forte_logo} alt="Forte_Logo" className="app-logo" />
              {/* <img src={abbvie_logo_main} alt="abbvie_logo_main" className="app-logo abbvie-logo-main" /> */}
            </div>
            <h1>AI Test Case Assistant</h1>
            <div className="logo-container right-logo">
              {isAuthenticated && <UserAccountMenu />}
            </div>
          </div>
        </header>
      )}
      <main className={`App-main ${isLandingPage ? 'landing-main' : ''}`}>
        <Routes>
          <Route path="/" element={<Landing />} />
          {/* Signup route disabled for security */}
          {/* <Route path="/signup" element={<SignUp />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          {/* Redirect to landing for any unmatched routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;